module.exports = __webpack_public_path__ + "img/图片2.f7bd001e.jpg";